import { Form, Skeleton } from "antd";
import { DownIcon } from "src/assets/Icons";
import { FC, ReactNode } from "react";

export type SorterLabel = Record<string, any>;

const SorterButton: FC<{
  sorter: any;
  value?: any;
  onChange?: any;
  isLoading?: boolean;
  labels: { minLabel: SorterLabel | null; maxLabel: SorterLabel | null };
  renderLabel: (label: SorterLabel | null) => ReactNode;
}> = ({
  sorter,
  value,
  onChange,
  isLoading,
  labels,
  renderLabel,
}) => {
  const handleClick = () => {
    onChange?.(!value);
  };

  const activeLabel = value ? labels.maxLabel : labels.minLabel;

  return (
    <div className="@container flex w-full cursor-pointer select-none flex-col items-start justify-center gap-1 p-1" onClick={handleClick}>
      <div className="flex w-full items-center justify-between font-bold">
        <div>{sorter.title}</div>
        <div>
          <DownIcon transform={`${!value ? "" : "scale(1,-1)"}`} />
        </div>
      </div>
      {isLoading ? (
        <Skeleton.Input active classNames={{ root: "h-4!", content: "h-full!" }} />
      ) : (
        renderLabel(activeLabel)
      )}
    </div>
  );
};

export default SorterButton;

export const SorterButtonField: FC<{
  sorter: any;
  valuesMap: any;
  isLoading?: boolean;
  labels: { minLabel: SorterLabel | null; maxLabel: SorterLabel | null };
  renderLabel: (label: SorterLabel | null) => ReactNode;
}> = ({
  sorter,
  isLoading,
  labels,
  renderLabel,
}) => {
  return (
    <Form.Item name={sorter.key} noStyle>
      <SorterButton sorter={sorter} isLoading={isLoading} labels={labels} renderLabel={renderLabel} />
    </Form.Item>
  );
};
